import { TFactoryConfigActions } from './factory-config.actions';
import { TFactoryConfigState, TFactoryConfigActionType } from './factory-config.models';

export const initialState: TFactoryConfigState = {
  factoryEfficiencyConfig: null,
  showEfficiencyLoader: false,
  factoryBenchmarkingConfig: null,
  showBenchmarkingLoader: false,
  factoryOtlOplConfig: null,
  showOtlOplLoader: false,
  factorySedConfig: null,
  showSedLoader: false,
  factoryExpectedDateConfig: null,
  showExpectedDateLoader: false,
  showTnaTargetUpdatesConfigLoader: false,
  tnaTargetUpdatesConfig: null,
  showAutoPlanConfigLoader: false,
  autoPlanConfig: null,
};

export function factoryConfigReducer(state = initialState, action: TFactoryConfigActions): TFactoryConfigState {
  switch (action.type) {
    case TFactoryConfigActionType.GetFactoryEfficiencyConfig:
      return {
        ...state,
        factoryEfficiencyConfig: null,
      };
    case TFactoryConfigActionType.GetFactoryEfficiencyConfigSuccess:
      return {
        ...state,
        factoryEfficiencyConfig: action.res,
      };
    case TFactoryConfigActionType.SetEfficiencyLoader:
      return {
        ...state,
        showEfficiencyLoader: action.showLoader,
      };
    case TFactoryConfigActionType.GetFactoryBenchmarkingConfig:
      return {
        ...state,
        factoryBenchmarkingConfig: null,
      };
    case TFactoryConfigActionType.GetFactoryBenchmarkingConfigSuccess:
      return {
        ...state,
        factoryBenchmarkingConfig: action.res,
      };
    case TFactoryConfigActionType.SetBenchmarkingLoader:
      return {
        ...state,
        showBenchmarkingLoader: action.showLoader,
      };
    case TFactoryConfigActionType.GetFactoryOtlOplConfig:
      return {
        ...state,
        factoryOtlOplConfig: null,
      };
    case TFactoryConfigActionType.GetFactoryOtlOplConfigSuccess:
      return {
        ...state,
        factoryOtlOplConfig: action.res,
      };
    case TFactoryConfigActionType.SetOtlOplLoader:
      return {
        ...state,
        showOtlOplLoader: action.showLoader,
      };
    case TFactoryConfigActionType.GetFactorySedConfig:
      return {
        ...state,
        factorySedConfig: null,
      };
    case TFactoryConfigActionType.GetFactorySedConfigSuccess:
      return {
        ...state,
        factorySedConfig: action.res,
      };
    case TFactoryConfigActionType.SetSedLoader:
      return {
        ...state,
        showSedLoader: action.showLoader,
      };

    case TFactoryConfigActionType.GetFactoryExpectedDateConfig:
      return {
        ...state,
        factoryExpectedDateConfig: null,
      };
    case TFactoryConfigActionType.GetFactoryExpectedDateConfigSuccess:
      return {
        ...state,
        factoryExpectedDateConfig: action.res,
      };
    case TFactoryConfigActionType.SetExpectedDateLoader:
      return {
        ...state,
        showExpectedDateLoader: action.showLoader,
      };

    case TFactoryConfigActionType.SetTnaTargetUpdatesConfigLoader:
      return {
        ...state,
        showTnaTargetUpdatesConfigLoader: action.showLoader,
      };
    case TFactoryConfigActionType.GetTnaTargetUpdatesConfig:
      return {
        ...state,
        tnaTargetUpdatesConfig: null,
      };
    case TFactoryConfigActionType.GetTnaTargetUpdatesConfigSuccess:
      return {
        ...state,
        tnaTargetUpdatesConfig: action.res,
      };
    case TFactoryConfigActionType.SetAutoPlanConfigLoader:
      return {
        ...state,
        showAutoPlanConfigLoader: action.showLoader,
      };
    case TFactoryConfigActionType.GetAutoPlanConfig:
      return {
        ...state,
        autoPlanConfig: null,
      };
    case TFactoryConfigActionType.GetAutoPlanConfigSuccess:
      return {
        ...state,
        autoPlanConfig: action.res,
      };

    case TFactoryConfigActionType.GetAllFactoryConfigs:
      return {
        ...state,
        factoryEfficiencyConfig: null,
        factoryBenchmarkingConfig: null,
        factoryOtlOplConfig: null,
        factorySedConfig: null,
        factoryExpectedDateConfig: null,
      };
    case TFactoryConfigActionType.GetAllFactoryConfigsSucccess:
      return {
        ...state,
        factoryEfficiencyConfig: action.efficiencyRes,
        factoryBenchmarkingConfig: action.benchmarkingRes,
        factoryOtlOplConfig: action.otlOplRes,
        factorySedConfig: action.sedRes,
        factoryExpectedDateConfig: action.expectedDateRes,
        tnaTargetUpdatesConfig: action.tnaTargetUpdatesRes,
        autoPlanConfig: action.autoPlanRes,
      };
    default:
      return state;
  }
}
